// The Noise Lab's two areas: training sets (recordings, edits, reviews) and model versions.
import { NavLink } from "react-router-dom";

export function LabTabs() {
  return (
    <nav className="lab-tabs" aria-label="Noise Lab">
      <NavLink end to="/admin/noise-lab" className={({ isActive }) => `lab-tab${isActive ? " on" : ""}`}>Training sets</NavLink>
      <NavLink to="/admin/noise-lab/models" className={({ isActive }) => `lab-tab${isActive ? " on" : ""}`}>Models</NavLink>
    </nav>
  );
}
